export default "<div style=cursor:pointer> <div class=equipment-name>{{group.name}}</div> <div class=count>{{group.inspectCount.count}}</div> <div ng-if=group.hasRejects> <span class=fail-rate>{{group.rejectCount.count}}</span> <span class=fail-percentage> <span>{{group.rejectCount.percent + \"%\"}}</span> <vert-trend trend=group.rejectCount.trend style=margin-top:.1em /> </span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/equipment-group.tpl.html
// module id = 436
// module chunks = 0